import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SendToAIParticipants = ({ studyId, studyType }) => {
  const navigate = useNavigate();
  return (
    <Button
      color="primary"
      size="large"
      onClick={() => navigate(`/ai-participants/study/${studyId}?type=${studyType || 'survey'}`)}
      fullWidth
      variant="contained"
    >
      Send To AI Participants
    </Button>
  );
};

export default SendToAIParticipants;
